import { gql } from 'apollo-angular';

export const ARTICLE_BASE_FRAGMENT = gql`
  fragment ArticleBaseFragment on Article {
    id
    mnr
    ean
    name
    description
    category {
      displayName
    }
    unit
    listPrice
    purchasePrice
  }
`;
